import moment from "moment-timezone";

export const formatDateTime = (isoString) => {
  if (!isoString) return "NA";

  return moment(isoString)
    .tz("Asia/Singapore")
    .format("YYYY-MM-DD HH:mm");
};
